import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss']
})
export class ServiceUnavailableComponent implements OnInit {

  browserLanguage = 'en';

  constructor(
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.browserLanguage = this.translateService.getBrowserLang();
  }

}
